import axios from "axios";
import { routes } from "./routes";

/**
 * Get the list of available live option expiration dates for a symbol
 * @param {string} symbol
 * @returns {Promise<{symbol: string, expirations: string[]}>} - expirations are YYYYMMDD
 */
export const apiGetOptionExpirations = async (symbol) => {
  const { data } = await axios.get(routes.getOptionExpirations(symbol));
  return data;
};

/**
 * Get the live option chain for a symbol/expiration
 * @param {string} symbol
 * @param {string} expiration - YYYYMMDD
 * @param {number} [strikesEachSide] - strikes around ATM to include (0 = ATM only); server default when omitted
 * @returns {Promise<{symbol: string, expiration: string, underlyingPrice: number, strikes: Array<{strike:number, bid:number, ask:number, last:number, iv:number}>}>}
 */
export const apiGetOptionChain = async (symbol, expiration, strikesEachSide) => {
  const { data } = await axios.get(routes.getOptionChain(symbol, expiration), {
    params: { strikesEachSide },
  });
  return data;
};

/**
 * Live ATM call quote for many symbols in one IBKR batch. Each item gets the
 * nearest expiration at least minDays trading bars out.
 * @param {Array<{symbol: string, minDays: number}>} items
 * @returns {Promise<{results: Array<{symbol, minDays, expiration, underlyingPrice, strike, bid, ask, last, iv, time} | {symbol, minDays, error}>}>}
 */
export const apiGetAtmCalls = async (items) => {
  const { data } = await axios.post(routes.getAtmCalls, { items });
  return data;
};
